<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
	<span class="navbar-brand"><img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;"></span>
	<span class="headerSpace">
	</span>
	<i class="fa fa-bars" aria-hidden="true" (click)="openDialog()" style="font-size: x-large; cursor:pointer;"></i>
</nav>

<div class="main-div">

	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-8">
        <h2 class="title">Dashboard</h2>
				<div class="form-holder">
					<div class="row justify-content-between">
						<div class="table-responsive">
						<table class="table" style="cursor: default">
							<tr>
								<td style="
								width: min-content;
								max-width: fit-content;
								padding: 0;
								border-top: 0;">
									<h3 class="mt-4 mb-0" style="color:#fbb01b;">Account:</h3>
								</td>
								<td  style="
								width: min-content;
								max-width: fit-content;
								padding: 0;
								border-top: 0;">
									<h3 class="mt-4 mb-0 text-right" style="color:#fbb01b;">Balance:</h3>
								</td>
							</tr>
							<tr>
								<td  style="
								width: min-content;
								max-width: fit-content;
								padding: 0;
								border-top: 0;">
									<h3 class="mt-2 mb-3 pr-2" style="color:#fbb01b;"><span style="color:white; font-size: smaller; cursor: pointer;" title="{{address}}"> {{modifiedAddress}}</span></h3>
								</td>
								<td  style="
								width: min-content;
								max-width: fit-content;
								padding: 0;
								border-top: 0;">
									<h3 class=" mt-2 mb-3 text-right pl-2" style="color:#fbb01b;"><span  style="color:white; font-size: smaller;"> {{balance | number:'2.8'}} {{symbol}}</span></h3>
								</td>
							</tr>
						</table>
					</div>
						<!-- <div class="col-md-4">
							<h3 class=" mt-4 mb-5" style="color:#fbb01b;">Account:<span style="color:white; font-size: smaller;"> {{modifiedAddress}}</span></h3>
						</div>
						<div class="col-md-4">
							<h3 class=" mt-4 mb-5" style="color:#fbb01b;">Balance:<span  style="color:white; font-size: smaller;"> {{helper.currentAccount.balance}} {{helper.currentAccount.symbol}}</span></h3>
						</div> -->
					</div>

					<div class="row mb-4">
						<div class="col-md-4 mb-2">
							<button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="route('transfer')">Send</button>
						</div>
						<div class="col-md-4 mb-2">
							<button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="route('txhistory')"> Tx History</button>
						</div>
						<div class="col-md-4 mb-2">
							<button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="route('receive')"> Receive</button>
						</div>
						<!-- <div class="col text-right">
							<button mat-stroked-button class="primary" (click)="route('import')">Remove</button>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
